export const CREATE_PROJECT = 'project'
export const SEARCH_PROJECT = 'search_project'
export const UPDATE_PROJECT = 'update_project'
export const PROJECT_PRICING = 'project_pricing'
export const INFRA_ID_FOR_VALET = 'INFRA_ID_FOR_VALET'
export const VALET_MONTHLY_DATA = 'VALET_MONTHLY_DATA'
export const CALCULATE_SALARY = 'CALCULATE_SALARY'
export const DAILY_SALARY_DISTRIBUTION = 'DAILY_SALARY_DISTRIBUTION'
export const MARK_HOLIDAYS_FOR_VALET = ' MARK_HOLIDAYS_FOR_VALET'
export const UPDATE_SALARY_STATUS = 'UPDATE_SALARY_STATUS'
export const ALL_RAISED_TICKETS = 'ALL_RAISED_TICKETS'
export const RESPOND_VALET_OPS = 'RESPOND_VALET_OPS'
export const STATUS_UPDATE_BY_VALET_HEAD = 'STATUS_UPDATE_BY_VALET_HEAD'
export const GET_EVENT_SALARY = 'GET_EVENT_SALARY'
export const APPROVE_EVENT_SALARY = 'APPROVE_EVENT_SALARY'
export const PENALTY_LISTING='PENALTY_LISTING'
export const MASTER_SALARY_PENALTY='MASTER_SALARY_PENALTY'
export const MASTER_SALARY_PENALTY_LIST='MASTER_SALARY_PENALTY_LIST'
export const SALARY_BY_PHONE_NO='SALARY_BY_PHONE_NO'
export const ALL_ABSCOND_DRIVERS = 'ALL_ABSCOND_DRIVERS'
export const RELEASE_ABSCOND_DRIVERS = 'RELEASE_ABSCOND_DRIVERS'
export const APPROVE_ABSCOND_DRIVERS = 'APPROVE_ABSCOND_DRIVERS'
export const ADVANCE_SALARY_LIST = 'ADVANCE_SALARY_LIST'
export const ADVANCE_SALARY_CALCULATE = 'ADVANCE_SALARY_CALCULATE'
export const ADVANCE_SALARY_UPDATE = 'ADVANCE_SALARY_UPDATE'